module.exports = __webpack_public_path__ + "img/red-packet-init.b8123af6.png";